import * as NodeActions from '~app/actions/node';
import createReducer from '~app/core/createReducer';
const uuidv4 = require('uuid/v4');

const initialState = {
  title: '',
  className: '',
  description: '',
  images: [null, null],
  attachments: [],
  id: '',
};

function create(state, {info}){
  return {
    ...initialState,
    ...info,
    id:uuidv4(),
  };
}

// Generic way to update single value parameters
// (title, description, color)
function update(state, {id, params}) {
  return id === state.id ? {
    ...state,
    ...params,
  } :
  state;
}

const ACTION_HANDLERS = {
  [NodeActions.UPDATE_NODE]: update,
  [NodeActions.CREATE_NODE]: create,
};

// Set title

// Set class

// Add/remove image

// Add/remove attachment

export default createReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/reducers/node.js